<template>
    <b-modal id="modal-distribuidor-detalhe" size="xl" :hide-header-close="true" :no-close-on-esc="true" :no-close-on-backdrop="true" ref="modalDistribuidorDetalhe">
       <template v-slot:modal-header="{ close }">
            <h5 v-if="!(loading || error)">Resumo do Título nº {{ nrTituloDisplay }}</h5>
        </template>
        <template v-slot:default="{ hide }">
            <template v-if="loading || error">
                <div v-if="loading" class="text-center"
                    style="
                        background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;
                        width: 100%;
                        height: 100%;
                        display: block;
                        z-index: 10002;
                        margin: 0;
                    "
                >
                    <b-spinner
                        variant="primary"
                        style="width: 3rem; height: 3rem"
                        label="Text Centered"
                    ></b-spinner>
                    <br /><span style="color: #004e86">Processando Aguarde...</span>
                </div>
            </template>
            <template v-else>
                <b-row>
                    <b-col class="col-xl-6 col-12 card-column-left">
                        <div class="modal-card">
                            <div class="modal-card-header">
                                <h3>Dados da Protocolização</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Chave Única:</b> {{ protocolo.chave_unica }}</span>
                                <span><b>N.º Protocolo:</b> {{ protocolo.n_protocolo }}</span>
                                <span><b>Data Protocolo:</b> {{ protocolo.data_protocolo }}</span>
                                <span><b>N.º Recibo:</b> {{ protocolo.nr_recibo }}</span>
                                <span><h3><b>Cartório</b></h3></span>
                                <hr/>
                                <span><b>Código:</b> {{ cartorio.cod_cartorio }}</span>
                                <span><b>Nome:</b> {{ cartorio.nome_cartorio }}</span>
                                <span><b>UF:</b> {{ cartorio.uf_cartorio }}</span>
                                <span><b>Código IBGE:</b> {{ cartorio.cd_ibge }}</span>
                                <span><b>Comarca:</b> {{ cartorio.comarca_cartorio }}</span>
                                <span><b>Endereço:</b> {{ cartorio.endereco_cartorio }}</span>
                                <span><b>Telefone:</b> {{ cartorio.cartorio_telefone }}</span>
                                <span><b>Horário de Funcionamento:</b> {{ cartorio.cartorio_hora_funcionamento }}</span>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="col-xl-6 col-12 card-column-right">
                        <div class="modal-card">
                            <div class="modal-card-header">
                                <h3>Dados do Título</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>N.º Título:</b> {{ titulo.n_titulo }}</span>
                                <span><b>Data da Remessa:</b> {{ titulo.data_remessa }}</span>
                                <span><b>Portador:</b> {{ titulo.portador }}</span>
                                <span><b>Nosso Número:</b> {{ titulo.nosso_numero }}</span>
                            </div>
                        </div>
                        <div class="modal-card">
                            <div class="modal-card-header">
                                <h3>Dados do Sacador</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Sacador:</b> {{ sacador.sacador }}</span>
                                <span><b>CNPJ:</b> {{ sacador.cnpj_sacador }}</span>
                            </div>
                        </div>
                        <div class="modal-card">
                            <div class="modal-card-header">
                                <h3>Dados do Pagador</h3>
                            </div>
                            <div class="modal-card-body">
                                <span><b>Cedente:</b> {{ pagador.pagador }}</span>
                                <span><b>CNPJ:</b> {{ pagador.cnpj_pagador }}</span>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </template>
        </template>
        <template v-slot:modal-footer="{ ok }">
            <b-button :disabled="loading" size="lg" variant="success" @click="devolveResposta('s')">Fechar</b-button>
        </template>
    </b-modal>
</template>
<script>

import API from '../../services/api';
export default {
    props:{
        reciboDados: {},
        nrTitulo: ''
    },
    data(){
        return{
            loading:false,
            error:false,
            resposta: 's',
            currencyFormatter: new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL'}),
            
            modalDistribuidorOk:false,
            carregando: false,
        }
    },
    methods: {
        devolveResposta(resposta) {
            this.loading = true;
            this.cleanModal();
            this.$emit('resposta',{respostaFinal: resposta});
            this.$bvModal.hide('modal-distribuidor-detalhe');
        },
        cleanModal(){
            this.nrTitulo = null;
            this.reciboDados = {};
        },
        // #region funções auxiliares para montar a apresentação de valores
        formatDataHora(string){
            let dt_hora = string ? string.split(' ')[0].split('-').reverse().join('/') : '';
            dt_hora = dt_hora != '' ? [dt_hora, string.split(' ')[1]].join(' ') : '';
            return dt_hora;
        },
        formatData(string){
            return string ? string.split('-').reverse().join('/') : '';
        },
        formatDocumento(string) {
            if (string == null) {
                return '';
            } else {
                let v = string;
                v = v.replace(/\D/g, "");
                if (v.length < 14) { //CPF
                    v = v.replace(/(\d{3})(\d)/, "$1.$2")
                            .replace(/(\d{3})(\d)/, "$1.$2")
                            .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
                } else { //CNPJ
                    v = v.replace(/^(\d{2})(\d)/, "$1.$2")
                            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                            .replace(/\.(\d{3})(\d)/, ".$1/$2")
                            .replace(/(\d{4})(\d)/, "$1-$2");
                }
                return v;
            }
        },
        formatCep(string) {
            if (string == null) return '';
            else return string.replace(/\D/g, '')
                                .replace(/(\d{5})(\d)/, '$1-$2')
                                .replace(/(-\d{3})\d+?$/, '$1');
        },
        formatPhone(string) {
            if (string == null) return '';
            else return string.replace(/\D/g, '')
                                .replace(/(\d{2})(\d)/, '($1) $2')
                                .replace(/(\d{5})(\d)/, '$1-$2')
                                .replace(/(-\d{4})\d+?$/, '$1');
        },
    },
    computed:{
        nrTituloDisplay(){
            if(this.nrTitulo !== undefined && this.nrTitulo !== null) return this.nrTitulo.toLocaleString();
            else return '';
        },
        protocolo(){
            if(this.reciboDados !== undefined && this.reciboDados !== null){
                let recibo             = this.reciboDados;
                let dadosProtocolo   = {
                    chave_unica: recibo.chave_unica,
                    n_protocolo: recibo.n_protocolo,
                    data_protocolo: this.formatData(recibo.data_protocolo),
                    nr_recibo: recibo.nr_recibo
                };
                return dadosProtocolo;
            }
            else return {}
        },
        cartorio(){
            if(this.reciboDados !== undefined && this.reciboDados !== null){
                let recibo     = this.reciboDados;
                let nrCartorio = !isNaN(parseInt(recibo.cod_cartorio, 10)) ? parseInt(recibo.cod_cartorio, 10) : '-';
                let dadosCartorio   = {
                    cod_cartorio: nrCartorio,
                    nome_cartorio: recibo.nome_cartorio,
                    uf_cartorio: recibo.uf_cartorio,
                    cd_ibge: recibo.cd_ibge,
                    comarca_cartorio: recibo.comarca_cartorio,
                    endereco_cartorio: recibo.endereco_cartorio,
                    cartorio_telefone: recibo.cartorio_telefone,
                    cartorio_hora_funcionamento: recibo.cartorio_hora_funcionamento
                };
                return dadosCartorio;
            }
            else return {}
        },
        titulo(){
            if(this.reciboDados !== undefined && this.reciboDados !== null){
                let recibo = this.reciboDados;
                let dadosTitulo   = {
                    n_titulo: recibo.n_titulo,
                    data_remessa: recibo.data_remessa,
                    portador: recibo.portador,
                    nosso_numero: recibo.nosso_numero
                };
                return dadosTitulo;
            }
            else return {}
        },
        sacador(){
            if(this.reciboDados !== undefined && this.reciboDados !== null){
                let recibo = this.reciboDados;
                return { sacador: recibo.sacador, cnpj_sacador: this.formatDocumento(recibo.cnpj_sacador) };
            }
            else return {}
        },
        pagador(){
            if(this.reciboDados !== undefined && this.reciboDados !== null){
                let recibo = this.reciboDados;
                return { pagador: recibo.pagador, cnpj_pagador: this.formatDocumento(recibo.cnpj_pagador) };
            }
            else return {}
        },
    },
}
</script>
<style scoped>

.modal-card{
    display: flex;
    flex-flow: column;
    box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
    margin-bottom: 30px;
    padding: 0 10px;
}
.modal-card-header{
    border-bottom: 1px solid rgba(0,0,0,.125);
    padding: .75rem 1.25rem;
}

h5 {
    font: normal normal 200 25px/25px 'Kanit', sans-serif;
	text-transform: none;
	letter-spacing: -1%;
    margin: 0px;
}
h3 {
    font: normal normal 200 20px/18px 'Kanit', sans-serif;
	text-transform: none;
	letter-spacing: -1%;
    color:var(--secondary-color) !important;
    margin: 0px;
}
span{
    margin-bottom: 18px;
    font: normal normal 200 16px/17px 'Kanit', sans-serif;
    letter-spacing: -1%;
}
.modal-card-body{
    padding: 1.25rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
}

.modal-card-body h3{ margin-top:1.25rem;}
hr{width: 100%;margin-bottom: 1rem;margin-top:0px;}
/* .card-column-left{max-width: 370px;} */
.card-column-left .modal-card-body{gap: 0;}
/* .card-column-right{max-width: calc(100% - 370px)} */
.card-column-left .modal-card-body span{
    flex: 1 1 100%;
    max-width: 100%;
}
.card-column-right .modal-card-body .row-body{
    flex: 1 1 95%;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
}
.card-column-right .modal-card-body .row-body span{
    flex: 1 1 49%;
    max-width: 49%;
}
.card-column-right .modal-card-body > span{
    flex: 1 1 100%;
    max-width: 100%;
}
.btn.btn-success{
    width: 160px;
    height: 44px;
    background: #1ACEB5 0% 0% no-repeat padding-box;
    font: normal normal bold 15px/15px 'Kanit', sans-serif;
    border-radius: 5px;
    opacity: 1;
    border: none;
    outline: none;
}
.btn.btn-success:disabled{
    background:#1aceb55c 0% 0% no-repeat padding-box
}
.btn.btn-success:active,
.btn.btn-success:focus{
    background: #1ACEB5 0% 0% no-repeat padding-box;
    box-shadow: none;
    border: none;
    outline: none;
}
.btn.download-ted {
    min-width: 195px;
    margin-left: auto;
}
.btn.download-ted > * {    
    color: white !important;
}

@media (max-width:1199px) {
    
    .card-column-left{max-width: unset;}
    .card-column-right{max-width: unset;}
    .card-column-right .modal-card-body > span{flex: 1 1 100%;max-width: 100%;}
    .card-column-right .modal-card-body .row-body span{flex: 1 1 100%;max-width: 100%;}
    .btn.download-ted{width: 100%;}
}

</style>